import React from 'react'

const GiftCardLoyaltyAndClosedLoop = () => {
  return (
    <div>GiftCard,LoyaltyAndClosedLoop</div>
  )
}

export default GiftCardLoyaltyAndClosedLoop